import { ConcreteEncodable } from "./ConcreteEncodable";

import { AdminModelUploadErrorImplEncoder } from "../../encoder/AdminModelUploadErrorImplEncoder";

import * as CubiqTS from "../../index";
import { AdminModelUploadError } from "../AdminModelUploadError";

export class AdminModelUploadErrorImpl extends ConcreteEncodable implements AdminModelUploadError {
  public static enType: string = "com.bcdfx.model.event.admin.AdminModelUploadErrorImpl";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=3*/
  public payload: string;
  /*FID=100*/
  public messageId: string;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AdminModelUploadErrorImplEncoder.Instance;
    this.setEncodableType(AdminModelUploadErrorImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AdminModelUploadErrorImpl[" +
      "id=" +
      this.id +
      "errors=" +
      this.errors +
      "payload=" +
      this.payload +
      "messageId=" +
      this.messageId +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
